import { render } from "./ReportsSystemView.vue?vue&type=template&id=00f5f9f6&scoped=true"
import script from "./ReportsSystemView.vue?vue&type=script&lang=js"
export * from "./ReportsSystemView.vue?vue&type=script&lang=js"

import "./ReportsSystemView.vue?vue&type=style&index=0&id=00f5f9f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f5f9f6"]])

export default __exports__